import eventsTemplate from './events.html';

const DEFAULT_NARRATIVE_TYPE = 0; // Events
const DEFAULT_NARRATIVE_PRIORITY = 0; // Detail
const SELECTED_NOTIFICATION_LOCAL_STORAGE_KEY = 'Selected-Notification';
const REQUEST_LIMIT = 100;

export default angular
  .module('main.locations.edit.tabs.events', [])

  .directive('editLocationEventsTab', () => {
    return {
      restrict: 'E',
      template: eventsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $state,
                   $filter,
                   utils,
                   config,
                   EditLocationDataProvider,
                   I18nService,
                   PermissionsService) => {
        const $t = $filter('translate');
        $scope.dataProvider = EditLocationDataProvider.instance;
        const locale = I18nService.getLocale()?.code || 'en';

        // Available narrative priorities
        $scope.showLogs = PermissionsService.canIViewLogs();
        $scope.narrativePriorities = config.getConfigByKey('narrativePriorities');
        if (!$scope.showLogs) {
          $scope.narrativePriorities = $scope.narrativePriorities.filter(el => !el.hidden);
        }

        // Available narrative types
        const narrativeTypes = config.getConfigByKey('narrativeTypes') || [];
        $scope.narrativeTypes = narrativeTypes.filter(el => !el.hidden);
        $scope.selectedNarrativeType = DEFAULT_NARRATIVE_TYPE;

        /**
         * Pair of start date and end date for the filter
         * @type {[Date, Date]}
         */
        $scope.eventsDate = null;

        $scope.timeFormatStr = $t('datetime.events.date');
        $scope.timestampFormatStr = $t('datetime.HMS12');
        $scope.currentTimezoneOffset = moment().tz(moment.tz.guess()).format('Z');

        // Search filter (persisted per location together with the other filters)
        $scope.filter = { searchVal: undefined };

        let narrativesList = [];

        angular.extend($scope, {
          onGoToScenesButtonClick: onGoToScenesButtonClick,
          onGoToPrioritiesButtonClick: onGoToPrioritiesButtonClick,
          onViewEventButtonClick: onViewEventButtonClick,
          toggleLogsOnly: toggleLogsOnly,
          isDefaultNarrativeType: isDefaultNarrativeType,
          searchEvents: searchEvents,
          toggleFilter: toggleFilter,
          closeFilter: closeFilter,
          isFilterDirty: isFilterDirty,
        });

        init();

        function init() {
          $scope.loading = true;
          initDatePicker();

          $q.all([
            $scope.dataProvider.locationIdResource.init(),
            $scope.dataProvider.locationTimeZoneIdResource.init(),
            $scope.dataProvider.locationTimeZoneOffsetResource.init(),
            $scope.dataProvider.locationOrganizationHasFeaturePResource.init()
          ])
            .then(() => {
              initInfiniteScroll();
              initFilterFromCache();
              initWatchers();
              $scope.locationTimeZoneOffset = $scope.dataProvider.locationTimeZoneOffsetResource.value;
              $scope.locationTimeZoneId = $scope.dataProvider.locationTimeZoneIdResource.value;
              $scope.hasFeatureP = $scope.dataProvider.locationOrganizationHasFeaturePResource.value;
              setDatePickerMaxDate();
              $scope.loading = false;
              return getEvents(false, true);
            }, (err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initWatchers() {
          $scope.$watchGroup([
            'selectedEventPriority',
            'selectedNarrativeType',
            'eventsDate'
          ], (newValue, oldValue) => {
            if (newValue[0] === oldValue[0] && newValue[1] === oldValue[1] && utils.compareArrays(oldValue[2], newValue[2])) {
              return;
            }

            // Reset logs only toggle when changing priority selection
            if ($scope.showLogsOnly && newValue[0] !== oldValue[0] && newValue[0] !== undefined) {
              $scope.showLogsOnly = false;
            }

            saveFilterToCache();
            return getEvents(false, true);
          });
        }

        function initDatePicker() {
          $scope.eventsDatePickerOptions = {
            language: locale,
            position: 'bottom left',
            view: 'days',
            minView: 'days',
            autoClose: true,
            clearButton: true,
            dateFormat: 'm/dd/yyyy',
            range: true,
            // toggleSelected: false
          };
        }

        function setDatePickerMaxDate() {
          let locationDate = moment().tz($scope.locationTimeZoneId).toDate();
          $scope.eventsDatePickerOptions = {
            ...$scope.eventsDatePickerOptions,
            maxDate: locationDate
          };
        }

        function initInfiniteScroll() {
          $('#narrative-list-container')
            .visibility({
              once: false,
              // Update size when new content loads
              observeChanges: true,
              // Load content on bottom edge visible
              onBottomVisible: function() {
                $scope.$applyAsync(() => {
                  showMore();
                });
              }
            });
        }

        function showMore() {
          if (!$scope.events || $scope.eventsCount <= 0 || !$scope.eventsNextMarker || $scope.loading || $scope.loadingMore) {
            return;
          }
          return getEvents(true, false);
        }

        function getEvents(loadMore, clearList) {
          if (clearList) {
            $scope.events = null;
            narrativesList = [];
          }
          let nextMarker = loadMore ? $scope.eventsNextMarker : null;
          if (loadMore) {
            $scope.loadingMore = true;
          } else {
            $scope.loading = true;
          }
          getLocationEvents(nextMarker)
            .then(() => {
              if (loadMore) {
                $scope.loadingMore = false;
              } else {
                $scope.loading = false;
              }
            });
        }

        function getLocationEvents(pageMarker) {
          let params = {
            rowCount: REQUEST_LIMIT,
          };

          if ($scope.showLogsOnly) {
            params.priority = $scope.narrativePriorities[0].id; // Logs
            params.toPriority = $scope.narrativePriorities[1].id; // Analytics
          } else {
            // Show events with selected priority and above
            if ($scope.selectedEventPriority || $scope.selectedEventPriority === 0) {
              params.priority = $scope.selectedEventPriority;
              params.toPriority = $scope.narrativePriorities[$scope.narrativePriorities.length - 1].id;
            } else {
              params.priority = $scope.narrativePriorities[0].id;
              params.toPriority = $scope.narrativePriorities[$scope.narrativePriorities.length - 1].id;
            }
          }

          if (!$scope.eventsDate || $scope.eventsDate.length === 0) {
            params.startDate = moment()
              .tz($scope.locationTimeZoneId)
              .startOf('day')
              .subtract(6, 'days') // 6 because current day counts
              .valueOf();
          } else {
            const endDate = $scope.eventsDate[$scope.eventsDate.length - 1];
            params.startDate = moment.tz(moment($scope.eventsDate[0])
              .format('L'), 'L', $scope.locationTimeZoneId)
              .startOf('day')
              .valueOf();
            params.endDate = moment.tz(moment(endDate)
              .format('L'), 'L', $scope.locationTimeZoneId)
              .endOf('day')
              .valueOf();
          }

          if (pageMarker) {
            params.pageMarker = pageMarker;
          }

          if ($scope.selectedNarrativeType > 0) {
            params.narrativeType = $scope.selectedNarrativeType;
          }

          // Search events by title (server-side, wildcard)
          if ($scope.filter && $scope.filter.searchVal) {
            params.searchBy = '*' + $scope.filter.searchVal + '*';
          }

          return $scope.dataProvider.getLocationNarratives(params)
            .then(data => {
              if (data.nextMarker) {
                $scope.eventsNextMarker = data.nextMarker;
              } else {
                delete $scope.eventsNextMarker;
              }

              narrativesList = narrativesList.concat(data.narratives || []);
              narrativesList = utils.uniqueArray(narrativesList, 'id');

              const groupedNarrativeList = utils.groupByDateParam(narrativesList, 'narrativeDateMs', $scope.locationTimeZoneId);

              $scope.events = groupedNarrativeList;
              $scope.eventsCount = narrativesList ? narrativesList.length : 0;
            }, err => {
              utils.handleApiError(err);
            });
        }

        function onGoToScenesButtonClick() {
          if ($scope.loading) {
            return;
          }
          $scope.dataProvider.activeTab = 'scenes';
        }

        function onGoToPrioritiesButtonClick() {
          if ($scope.loading) {
            return;
          }
          $scope.dataProvider.activeTab = 'priorities';
        }

        /**
         * Goes to the Notification Info page
         */
        function onViewEventButtonClick(event) {
          if ($scope.loading || !event) {
            return;
          }

          utils.setStorageItem(SELECTED_NOTIFICATION_LOCAL_STORAGE_KEY, event);
          $state.go('main.notifications.info', {
            from: 'location',
            locationId: $scope.dataProvider.locationIdResource.value
          });
        }

        function initFilterFromCache() {
          try {
            let savedCache = JSON.parse(sessionStorage.getItem(`maestro-location-events-filter-${$scope.dataProvider.locationIdResource.value}`));

            if (!savedCache) {
              // Initial narrative priority selection
              $scope.selectedEventPriority = $scope.narrativePriorities.find(el => el.id === DEFAULT_NARRATIVE_PRIORITY).id;
              return;
            }

            if (savedCache.eventsDate) {
              if (angular.isString(savedCache.eventsDate)) {
                savedCache.eventsDate = [new Date(savedCache.eventsDate)];
              } else if (angular.isArray(savedCache.eventsDate)) {
                savedCache.eventsDate = savedCache.eventsDate.map(e => new Date(e));
              } else {
                savedCache.eventsDate = undefined;
              }
            }

            // Save narrative priority selection into cache
            if ($scope.selectedEventPriority && !$scope.narrativePriorities.some(p => p.id === $scope.selectedEventPriority)) {
              savedCache.selectedEventPriority = $scope.selectedEventPriority;
            }

            // Save narrative type selection into cache
            if ($scope.selectedNarrativeType) {
              savedCache.selectedNarrativeType = $scope.selectedNarrativeType;
            }

            // Initial narrative priority selection
            $scope.selectedEventPriority =
              !$scope.showLogsOnly && ($scope.narrativePriorities.some(p => p.id === savedCache.selectedEventPriority) || savedCache.selectedEventPriority === null)
              ? savedCache.selectedEventPriority : null;

            $scope.selectedNarrativeType = savedCache.selectedNarrativeType;
            $scope.showLogsOnly = savedCache.showLogsOnly || false;
            $scope.eventsDate = savedCache.eventsDate;
            $scope.filter.searchVal = savedCache.searchVal || undefined;
          } catch (err) {
            console.warn(err);
          }
        }

        function saveFilterToCache() {
          let cacheEntry = {
            selectedEventPriority: $scope.selectedEventPriority,
            selectedNarrativeType: $scope.selectedNarrativeType,
            showLogsOnly: $scope.showLogsOnly || false,
            eventsDate: $scope.eventsDate || undefined,
            searchVal: ($scope.filter && $scope.filter.searchVal) || undefined
          };

          sessionStorage.setItem(`maestro-location-events-filter-${$scope.dataProvider.locationIdResource.value}`, JSON.stringify(cacheEntry));
        }

        /**
         * Trigger a server-side search by event title and persist it.
         */
        function searchEvents() {
          if ($scope.loading) {
            return;
          }
          saveFilterToCache();
          return getEvents(false, true);
        }

        function toggleLogsOnly() {
          $scope.showLogsOnly = !$scope.showLogsOnly;
          $scope.selectedEventPriorityTemp = $scope.showLogsOnly && angular.copy($scope.selectedEventPriority);
          $scope.selectedEventPriority = $scope.showLogsOnly ? undefined : angular.copy($scope.selectedEventPriorityTemp);
        }

        function isDefaultNarrativeType() {
          return !$scope.selectedNarrativeType || $scope.selectedNarrativeType === DEFAULT_NARRATIVE_TYPE;
        }

        /**
         * Toggle filter panel visibility.
         */
        function toggleFilter() {
          $('#filter').transition('fade down');
        }

        /**
         * Hide the filter panel.
         */
        function closeFilter() {
          let visible = $('#filter').transition('is visible');
          if (visible) {
            $('#filter').transition('hide');
          }
        }

        /**
         * Whether any filter differs from its default (used to highlight the filter button).
         * @return {boolean}
         */
        function isFilterDirty() {
          return $scope.selectedEventPriority !== DEFAULT_NARRATIVE_PRIORITY
            || !!$scope.showLogsOnly
            || $scope.selectedNarrativeType > DEFAULT_NARRATIVE_TYPE;
        }
      }
    };
  })
  .name;
